export default "__VITE_ASSET__DMfDDrWK__"